import { FilterGroup } from '../DTO/filtering/filter-group';
import { Filter } from '../DTO/filtering/filter';

export class Utils {
  static isNullOrWhiteSpaceString(s: any): boolean {
    return typeof s !== "string" || s.trim().length === 0;
  }

  static getFormUrlEncodedObject(obj: any): string {
    let formUrlEncoded = "";
    for (const prop of Object.keys(obj)) {
      formUrlEncoded +=
        encodeURIComponent(prop) + "=" + encodeURIComponent(obj[prop]) + "&";
    }
    formUrlEncoded = formUrlEncoded.slice(0, -1);
    return formUrlEncoded;
  }

  static cancelOutLocalTimeZone(date: Date) {
    if (date !== null && date !== undefined) {
      date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    }
  }

  static getSlashTrimmedString(source: string): string {
    if (!source) {
      return source;
    }
    while (source.length > 0 && source[0] === "/") {
      source = source.substr(1);
    }
    while (source.length > 0 && source[source.length - 1] === "/") {
      source = source.substr(0, source.length - 1);
    }
    return source;
  }

  static getUrlParameter(name: string): string {
    const query = window.location.search.substring(1);
    const variables = query.split("&");
    for (let i = 0; i < variables.length; ++i) {
      const pair = variables[i].split("=");
      if (pair[0] === name) {
        return pair[1];
      }
    }
    return null;
  }

  static getRedirectUriForAuthPortal(): string {
    // The redirect Uri needs to be without any query parameters
    const protocol = Utils.getSlashTrimmedString(window.location.protocol);
    const host = Utils.getSlashTrimmedString(window.location.host);
    // let pathname = Utils.getSlashTrimmedString(window.location.pathname);
    return encodeURI(protocol + "//" + host + window.location.pathname);
  }

  static getCurrentUrlWithoutPath(): string {
    const protocol = Utils.getSlashTrimmedString(window.location.protocol);
    const host = Utils.getSlashTrimmedString(window.location.host);
    // let pathname = Utils.getSlashTrimmedString(window.location.pathname);
    return encodeURI(protocol + "//" + host);
  }

  static objectToBase64(object: any): string {
    const returnString = window.btoa(JSON.stringify(object));
    return returnString;
  }

  static objectFromBase64<T = any>(base64Object: any): T {
    const returnObject = JSON.parse(window.atob(base64Object));
    return returnObject;
  }
}
